<template>
  <div>
    <!-- <h4 v-if="!curricular_mesh" class="mt-2">
      {{
        $getVisibleNames(
          "mesh.egressprofilecompetencemention",
          true,
          "Menciones"
        )
      }}
    </h4> -->
    <b-table-simple responsive>
      <b-thead>
        <b-tr>
          <b-th
            style="width: 3%"
            class="text-center"
            v-if="allows_crud && can_update && draggableList.length > 0"
          >
          </b-th>
          <b-th
            :style="`width: ${
              curricular_mesh ? 45 : hasMultipleTypes ? 17 : 22
            }%`"
            class="text-center"
          >
            {{ singleTypeName }}
          </b-th>
          <b-th
            v-if="hasMultipleTypes"
            :style="`${!curricular_mesh ? 'width: 10%' : 'width: 20%'}`"
            class="text-center"
          >
            Tipo
          </b-th>
          <b-th v-if="!curricular_mesh" style="width: 25%" class="text-center">
            {{ $t("reusable.common.description") }}
          </b-th>
          <b-th style="width: 47%" class="text-center">
            {{ $getVisibleNames("mesh.competence", true, "Competencias") }}
            <div class="profile-competence-button-div">
              <ButtonMedium
                v-if="allows_crud && can_update"
                :tooltip_text="
                  $t('reusable.common.createTooltip', {
                    entity: $getVisibleNames(
                      'mesh.egressprofilecompetencemention',
                      false,
                      'Mención'
                    ),
                  })
                "
                :text_button="$t('reusable.common.create')"
                :click_button="
                  () =>
                    $bvModal.show(
                      `add-profile-competence-mention-modal-${egress_profile_id}`
                    )
                "
                :icon="'plus'"
                :variant="'primary'"
              >
              </ButtonMedium>
            </div>
          </b-th>
          <b-th
            style="width: 2%"
            v-if="
              allows_crud &&
              (can_update || can_delete) &&
              draggableList.length > 0
            "
          ></b-th>
        </b-tr>
      </b-thead>
      <draggable
        v-model="draggableList"
        :disabled="!(allows_crud && can_update)"
        tag="b-tbody"
        handle=".handle"
      >
        <template v-if="draggableList.length > 0">
          <b-tr v-for="mention in draggableList" :key="mention.id">
            <b-td
              style="
                border: 1px solid var(--kl-table-border);
                height: 4rem !important;
              "
              class="text-center handle"
              :class="{ grabbable: allows_crud && can_update }"
              v-if="allows_crud && can_update"
              ><b-icon
                v-if="allows_crud && can_update"
                icon="arrows-expand"
                scale="1.2"
              ></b-icon
            ></b-td>
            <b-td
              style="
                border: 1px solid var(--kl-table-border);
                height: 4rem !important;
              "
              class="text-center"
            >
              {{ mention.name }}</b-td
            >
            <b-td
              style="
                border: 1px solid var(--kl-table-border);
                height: 4rem !important;
              "
              class="text-center"
              v-if="hasMultipleTypes"
            >
              {{ getTypeName(mention) }}
            </b-td>
            <b-td
              style="
                border: 1px solid var(--kl-table-border);
                height: 4rem !important;
              "
              v-if="!curricular_mesh"
              class="px-2"
            >
              <RenderVHtml :content="mention.description"></RenderVHtml>
            </b-td>
            <b-td
              style="
                border: 1px solid var(--kl-table-border);
                height: 4rem !important;
              "
              :class="
                mention.egress_profile_competences.length > 0
                  ? 'text-justify'
                  : 'text-center'
              "
            >
              <template v-if="mention.egress_profile_competences.length > 0">
                <div
                  :class="
                    !curricular_mesh ? 'badge-containerEPC ' : 'badge-container'
                  "
                >
                  <div
                    v-for="profile_competence in ProfileCompetenceMentionBadge(
                      mention.egress_profile_competences
                    )"
                    :key="profile_competence.id + '-' + mention.id"
                    :id="profile_competence.id + '-' + mention.id"
                    :class="!curricular_mesh ? 'badgeEPC' : 'badge'"
                  >
                    {{ profile_competence.order
                    }}{{
                      profile_competence.profile_cycle_order != 1000
                        ? "." + profile_competence.profile_cycle_order
                        : ""
                    }}
                    <b-popover
                      :target="profile_competence.id + '-' + mention.id"
                      placement="left"
                      triggers="hover focus"
                    >
                      <div class="competence-div d-flex">
                        <span>
                          {{ profile_competence.order
                          }}{{
                            profile_competence.profile_cycle_order != 1000
                              ? "." + profile_competence.profile_cycle_order
                              : ""
                          }}
                        </span>
                        <SentenceContainer
                          :Sentence="profile_competence"
                        ></SentenceContainer>
                      </div>
                    </b-popover>
                  </div>
                </div>
              </template>
              <template v-else>
                {{ $t("reusable.common.notApplicable") }}
              </template>
            </b-td>
            <b-td
              style="
                border: 1px solid var(--kl-table-border);
                height: 4rem !important;
              "
              class="text-center"
              v-if="allows_crud"
            >
              <ButtonSmall
                v-if="can_update && allows_crud"
                :tooltip_text="
                  $t('reusable.common.editTooltip', {
                    entity: $getVisibleNames(
                      'mesh.egressprofilecompetencemention',
                      false,
                      'Mención'
                    ),
                  })
                "
                :click_button="
                  () =>
                    $bvModal.show(
                      `edit-profile-competence-mention-modal-${mention.id}`
                    )
                "
                :class="`mr-1`"
                :icon="'square'"
              ></ButtonSmall>
              <!-- <button-edit
                v-if="can_update && allows_crud"
                fill="white"
                v-b-tooltip.v-secondary.noninteractive.top="
                  $t('reusable.common.editTooltip', {
                    entity: $getVisibleNames(
                      'mesh.egressprofilecompetencemention',
                      false,
                      'Mención'
                    ),
                  })
                "
                @click="
                  $bvModal.show(
                    `edit-profile-competence-mention-modal-${mention.id}`
                  )
                "
              ></button-edit> -->
              <ButtonSmall
                v-if="can_delete && allows_crud"
                :tooltip_text="
                  $t('reusable.common.deleteTooltip', {
                    entity: $getVisibleNames(
                      'mesh.egressprofilecompetencemention',
                      false,
                      'Mención'
                    ),
                  })
                "
                :class="`mr-1`"
                :click_button="() => askForDeleteObject(mention)"
                :icon="'trash'"
              ></ButtonSmall>
              <!-- <button-delete
                v-if="can_delete && allows_crud"
                v-b-tooltip.v-secondary.noninteractive.top="
                  $t('reusable.common.deleteTooltip', {
                    entity: $getVisibleNames(
                      'mesh.egressprofilecompetencemention',
                      false,
                      'Mención'
                    ),
                  })
                "
                @click="askForDeleteObject(mention)"
              ></button-delete> -->
              <b-modal
                :id="`edit-profile-competence-mention-modal-${mention.id}`"
                :hide-footer="true"
                :title="
                  $t('reusable.common.editModalTitle', {
                    entity: $getVisibleNames(
                      'mesh.egressprofilecompetencemention',
                      false,
                      'Mención'
                    ),
                  })
                "
                size="xl"
              >
                <EgressProfileCompetenceMentionForm
                  :ProfileCompetenceMention="mention"
                  :show_delete_button="can_delete"
                  :egress_profile_id="egress_profile_id"
                  @updated="
                    $bvModal.hide(
                      `edit-profile-competence-mention-modal-${mention.id}`
                    )
                  "
                ></EgressProfileCompetenceMentionForm>
              </b-modal>
            </b-td>
          </b-tr>
        </template>
        <b-tr v-else>
          <b-td
            style="
              border: 1px solid var(--kl-table-border);
              height: 4rem !important;
            "
            class="text-center"
            colspan="8"
            >{{
              $t("curricularMesh.curricularMeshView.noDataToShow", {
                entity: $getVisibleNames(
                  "mesh.egressprofilecompetencemention",
                  true,
                  "Menciones"
                ).toLowerCase(),
              })
            }}</b-td
          >
        </b-tr>
      </draggable>
    </b-table-simple>
    <b-modal
      :id="`add-profile-competence-mention-modal-${egress_profile_id}`"
      :hide-footer="true"
      :title="
        $t('reusable.common.createModalTitle', {
          entity: $getVisibleNames(
            'mesh.egressprofilecompetencemention',
            false,
            'Mención'
          ),
        })
      "
      size="xl"
    >
      <EgressProfileCompetenceMentionForm
        :egress_profile_id="egress_profile_id"
        @created="
          $bvModal.hide(
            `add-profile-competence-mention-modal-${egress_profile_id}`
          )
        "
      ></EgressProfileCompetenceMentionForm>
    </b-modal>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";
export default {
  name: "EgressProfileCompetenceMention",
  components: {
    draggable,
    EgressProfileCompetenceMentionForm: () =>
      import("./EgressProfileCompetenceMentionForm"),
    SentenceContainer: () => import("@/components/reusable/SentenceContainer"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
  },
  props: {
    type: Number,
    egress_profile_id: {
      required: true,
    },
    allows_crud: {
      type: Boolean,
    },
    can_update: {
      type: Boolean,
      default: false,
    },
    can_delete: {
      type: Boolean,
      default: false,
    },
    curricular_mesh: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      typeChoices: {
        1: "Mención",
        2: "Diploma",
        3: "Especialización",
        4: "Certificación",
        5: "Otro",
      },
    };
  },
  computed: {
    ...mapGetters({
      competences: names.COMPETENCES,
      egressProfileCycles: names.PROFILE_CYCLES,
      profile_competences: names.PROFILE_COMPETENCES,
      profile_competences_mention: names.PROFILE_COMPETENCES_MENTION,
    }),
    hasMultipleTypes() {
      const types = new Set(
        this.draggableList
          .map((item) => {
            // Si el tipo es 5 (Otro), usar el other_type_name para diferenciar
            if (item.type === 5 && item.other_type_name) {
              return `5_${item.other_type_name.toUpperCase()}`;
            }
            return item.type;
          })
          .filter((type) => type !== null)
      );
      return types.size > 1;
    },
    singleTypeName() {
      if (this.draggableList.length === 0)
        return this.$getVisibleNames(
          "mesh.egressprofilecompetencemention",
          false,
          "Mención"
        );
      if (this.hasMultipleTypes) return "Nombre";
      const firstType = this.draggableList.find(
        (item) => item.type !== null
      )?.type;
      if (firstType) {
        const mention = this.draggableList.find(
          (item) => item.type === firstType
        );
        if (firstType === 5 && mention?.other_type_name) {
          return mention.other_type_name;
        }
        return this.typeChoices[firstType] || "Nombre";
      }
      return "Nombre";
    },
    draggableList: {
      get() {
        let list = this.profile_competences_mention.filter(
          (x) => x.egress_profile == this.egress_profile_id
        );
        list.sort(function (a, b) {
          if (a.order < b.order) return -1;
          if (a.order > b.order) return 1;
          return 0;
        });
        let order = 1;
        list.forEach((element) => {
          if (element.order != order) element.order = order;
          order += 1;
        });
        return list;
      },
      set(list) {
        let order = 1;
        list.forEach((element) => {
          if (element.order != order) {
            element.order = order;
            if (!isNaN(element.id)) {
              this.patchMention({
                profile_competence_mention_id: element.id,
                item: { order: element.order },
              });
            }
          }
          order += 1;
        });
      },
    },
  },
  methods: {
    getTypeName(mention) {
      if (mention.type === 5 && mention.other_type_name) {
        return mention.other_type_name;
      }
      return this.typeChoices[mention.type] || "N/A";
    },
    ProfileCompetenceMentionBadge(profile_competences_mention) {
      let list = [];
      list = this.profile_competences
        .filter(
          (x) =>
            x.egress_profile == this.egress_profile_id &&
            profile_competences_mention.includes(x.id)
        )
        .map((objeto) => {
          const competence = this.competences.find(
            (x) => x.id == objeto.competence
          ) || {
            action: "",
            content: "",
            condition: "",
            verb: null,
            full_sentence: "",
          };
          return {
            ...objeto,
            action: competence.action,
            content: competence.content,
            condition: competence.condition,
            verb: competence.verb,
            full_sentence: competence.full_sentence,
            profile_cycle_order: (
              this.egressProfileCycles.find(
                (x) =>
                  x.egress_profile == this.egress_profile_id &&
                  x.cycle == objeto.cycle
              ) || { order: 1000 }
            ).order,
          };
        });
      return list.sort(function (a, b) {
        if (a.order > b.order) return 1;
        if (a.order < b.order) return -1;
        if (a.profile_cycle_order > b.profile_cycle_order) return 1;
        if (a.profile_cycle_order < b.profile_cycle_order) return -1;
        return 0;
      });
    },
    patchMention(payload) {
      this.$store.dispatch(names.PATCH_PROFILE_COMPETENCE_MENTION, payload);
    },
    askForDeleteObject(profile_competence_mention) {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.egressprofilecompetencemention",
            false,
            "Mención"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch(
            names.DELETE_PROFILE_COMPETENCE_MENTION,
            profile_competence_mention.id
          );
          toast(
            String(
              this.$getVisibleNames(
                "mesh.egressprofilecompetencemention",
                false,
                "Mención"
              ) +
                " " +
                this.$t("reusable.common.deleted")
            )
          );
        }
      });
    },
  },
  mounted() {},
  created() {
    // this.$store.dispatch(names.FETCH_PROFILE_COMPETENCES_MENTION, {
    //   egress_profile_id: this.egress_profile_id,
    // });
  },
};
</script>

<style scoped>
table th {
  border: 1px solid var(--kl-table-border);
  vertical-align: middle;
  background-color: var(--kl-color-accent-medium) !important;
  color: var(--kl-text-on-primary);
  font-weight: var(--kl-fw-bold);
  font-size: var(--primary-font-size);
  padding: 2px 2px;
}
.profile-competence-mention-header {
  background: var(--kl-color-accent-medium) !important;
  color: var(--kl-text-on-primary) !important;
}
.profile-competence-button-div {
  float: right;
}
table td {
  text-align: left;
  vertical-align: middle;
  font-size: var(--secondary-font-size);
  padding: 2px 2px;
}
.grabbable {
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}
.grabbable:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}
.badge-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: left;
}
.badge {
  background-color: var(--kl-chip-bg);
  color: var(--kl-chip-text);
  border: 1px solid var(--kl-chip-border);
  max-width: fit-content;
  border-radius: var(--kl-radius-pill);
  margin: 0.1em 0.1em;
  padding: var(--kl-chip-padding);
  flex-grow: 1;
  font-size: var(--kl-chip-fs);
  font-weight: var(--kl-chip-fw);
  text-align: center;
}
.badge-containerEPC {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0.2em 0em;
  gap: 5px;
  justify-content: center;
}
.badgeEPC {
  background-color: var(--kl-chip-solid-bg);
  color: var(--kl-chip-solid-text);
  font-weight: var(--kl-chip-fw);
  max-width: fit-content;
  border-radius: var(--kl-radius-pill);
  margin: 0.1em 0.1em;
  padding: 0.4em 0.8em;
  line-height: 1;
  flex-grow: 1;
  font-size: var(--kl-chip-fs);
  text-align: center;
}
@media print {
  .badge {
    border: none;
  }
}
</style>